import {gsap} from 'gsap';
const {registerModule, KitModule} = window;

class StatisticItem extends KitModule {
  constructor($element) {
    super($element);

    this.bindSetttings();
    this.bindObserver();
  }

  bindSetttings() {
    this.observer = null;
    this.options = {
      rootMargin: '0px',
      threshold: 0,
    };
  }

  bindObserver() {
    this.observer = new IntersectionObserver(this.observerCallback.bind(this), this.options);
    this.observer.observe(this.$element);
  }

  observerCallback(entries) {
    entries.forEach((entry) => {
      if (entry.isIntersecting) {
        this.animate();
        this.observer.unobserve(entry.target);
      }
    });
  }

  animate() {
    const target = {val: 0};
    const count = this.$number[0];
    const finalNumber = count.getAttribute('data-number');

    gsap.to(target, {
      val: finalNumber,
      duration: 2,
      onUpdate: () => {
        const value = parseFloat(target.val);

        if (finalNumber >= 1000) {
          // Use 'en' formatting to add comma formatting — ex., '1,000'
          count.textContent = parseInt(value.toFixed(0)).toLocaleString('en');
        } else {
          count.textContent = value.toFixed(0);
        }
      },
    });
  }
}

registerModule('StatisticItem', StatisticItem);
